<template>
  <div>
    <seccion-main/>
  </div>
</template>
<script>
import SeccionMain from '../clubdegolf/mapLocation/SeccionMain.vue'
export default {
  name: "SubMenu",
  components: {
    SeccionMain
  }
}
</script>
<style scoped>
</style>